// extracted by mini-css-extract-plugin
export default {"appointmentCandidate":"ORwjgtWUMUXqpIv0m30z","disabled":"uQFDhEZO50RhOtMgDlHk"};